import { render, staticRenderFns } from "./WeeklyDebtsUi.vue?vue&type=template&id=18097f06&scoped=true"
import script from "./WeeklyDebtsUi.vue?vue&type=script&lang=js"
export * from "./WeeklyDebtsUi.vue?vue&type=script&lang=js"
import style0 from "./WeeklyDebtsUi.vue?vue&type=style&index=0&id=18097f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18097f06",
  null
  
)

export default component.exports